<template>
  <div>
    <div class="h2">
      Assureur précédent
    </div>

    <!-- Nom de l'assureur -->
    <InputText
      label="Nom de l'assureur"
      slug="nomAssureur"
      :model="nomAssureur"
      :v$="v$"
      @input="$emit('update:nomAssureur', $event.target.value)"
    />

    <!-- Adresse de l'assureur -->
    <InputText
      label="Adresse"
      slug="adresseAssureur"
      :model="adresseAssureur"
      :v$="v$"
      @input="$emit('update:adresseAssureur', $event.target.value)"
    />

    <!-- Code postal et ville de d'assureur -->
    <zip-code-and-city-form
      :code-postal="codePostalAssureur"
      code-postal-slug="codePostalAssureur"
      code-postal-label="Code postal"
      :ville="villeAssureur"
      ville-slug="villeAssureur"
      ville-label="Ville"
      :v$="v$"
      @update-code-postal="$emit('update:codePostalAssureur', $event)"
      @update-ville="$emit('update:villeAssureur', $event)"
    />

    <!-- Pays de l'assureur -->
    <InputText
      label="Pays de l'assureur"
      slug="paysAssureur"
      :model="paysAssureur"
      :v$="v$"
      @input="$emit('update:paysAssureur', $event.target.value)"
    />

    <!-- Numéro de contrat -->
    <InputText
      label="Numéro de contrat"
      slug="numeroContratAssureur"
      :model="numeroContratAssureur"
      :v$="v$"
      @input="$emit('update:numeroContratAssureur', $event.target.value)"
    />

    <!-- Nom du contrat -->
    <InputText
      label="Nom du contrat"
      slug="nomContratAssureur"
      :model="nomContratAssureur"
      :v$="v$"
      @input="$emit('update:nomContratAssureur', $event.target.value)"
    />
  </div>
</template>

<script>

import useVuelidate from '@vuelidate/core'
import {frenchZipCode, maxLength, required, serverError} from "src/modules/shared/validators/validators";
import {computed } from "vue";
import InputText from "src/modules/shared/components/Form/InputText";
import ZipCodeAndCityForm from "src/modules/shared/components/Form/ZipCodeAndCityForm";

export default {
  name: "InsurerInformationForm",
  components: {
    InputText,
    ZipCodeAndCityForm
  },
  props: {
    serverErrors: {
      type: Array,
      required: true
    },
    nomAssureur: {
      type: String,
      required: true
    },
    adresseAssureur: {
      type: String,
      required: true
    },
    codePostalAssureur: {
      type: String,
      required: true
    },
    villeAssureur: {
      type: String,
      required: true
    },
    paysAssureur: {
      type: String,
      required: true
    },
    numeroContratAssureur: {
      type: String,
      required: true
    },
    nomContratAssureur: {
      type: String,
      required: true
    }
  },
  emits: [
    'update:nomAssureur',
    'update:adresseAssureur',
    'update:codePostalAssureur',
    'update:villeAssureur',
    'update:paysAssureur',
    'update:numeroContratAssureur',
    'update:nomContratAssureur'
  ],
  setup (props) {
    const validations = computed(() => ({
      nomAssureur: {
        required,
        maxLength: maxLength(25),
        serverError: serverError(props, 'nomAssureur')
      },
      adresseAssureur: {
        required,
        maxLength: maxLength(32),
        serverError: serverError(props, 'adresseAssureur')
      },
      codePostalAssureur: {
        required,
        frenchZipCode,
        serverError: serverError(props, 'codePostalAssureur')
      },
      villeAssureur: {
        required,
        serverError: serverError(props, 'villeAssureur')
      },
      paysAssureur: {
        required,
        maxLength: maxLength(32),
        serverError: serverError(props, 'paysAssureur')
      },
      numeroContratAssureur: {
        required,
        maxLength: maxLength(25),
        serverError: serverError(props, 'numeroContratAssureur')
      },
      nomContratAssureur: {
        required,
        maxLength: maxLength(32),
        serverError: serverError(props, 'nomContratAssureur')
      }
    }))

    const v$ = useVuelidate(validations, props)

    return { v$ }
  },
  watch: {
    serverErrors () {
      this.v$.$reset()
      this.v$.$touch()
    }
  },
}
</script>

<style scoped>

</style>
